import React from "react";
import SubPageTheme from "../../components/SubPageTheme";
import { webDevData } from "../../utils/data";

export default function WebDev(props) {
  return <SubPageTheme {...webDevData} />;
}
